export enum FILTER_KIND {
  PRIVATE = 'private',
  PUBLIC = 'public',
}
